import EyeOpenStrikethroughIcon from '@atlaskit/icon/core/eye-open-strikethrough';
import * as React from 'react';

export function SvgEyeOff() {
  return <EyeOpenStrikethroughIcon label="" testId="ads-refreshed-icon" />;
}
